<div class="dashboard-scroll-container">
  <dashboard-lib-dashboards-treeview [enableModule]="false"> </dashboard-lib-dashboards-treeview>
</div>
